import { styled, css } from "styled-components";

export const StyledFormationCM = styled.div<{ $isModal?: boolean }>`
  ${({ $isModal = false }) =>
    $isModal
      ? css`
          width: 60vw;
          height: 60vh;

          @media (max-width: ${({ theme }) => theme.breakpoints.XL}px) {
            width: 80vw;
            height: 60dvh;
          }
        `
      : css`
          width: 100%;
        `}

  & .empty-content {
    margin-top: 36px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .cm-formation-header-container {
    margin-bottom: 20px;

    & .filters {
      display: flex;
      flex-direction: row;
      gap: 16px;
      flex-wrap: wrap;
      justify-content: flex-end;

      & > div {
        width: 250px;
      }
    }
  }

  & .grid-cols-2 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;
